export default __webpack_public_path__ + "static/workout-planner-8cf804455dad113e9fdbb046fdb11f23.gif";